// resources/assets/js/partials/images.js
// Vanilla Chocolat per official docs
// Install: npm i chocolat
// CSS: import 'chocolat/dist/css/chocolat.css' in your entry
import Chocolat from "chocolat";

/**
 * Initialize Chocolat on all .chocolat-image anchors (within .js-chocolat).
 * Docs: Chocolat(document.querySelectorAll('.chocolat-image'), options)
 */
export function initChocolatGalleries() {
  // select only anchors inside our gallery wrappers
  var nodes = document.querySelectorAll(".js-chocolat .chocolat-image");
  if (!nodes || !nodes.length) return;

  // one call per page is fine (Chocolat handles the NodeList)
  Chocolat(nodes, {
    imageSize: "contain",
    loop: true,
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/partials/images.js